import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Card, CardContent, CardMedia, Typography, IconButton } from "@material-ui/core";
import RemoveIcon from "@material-ui/icons/Remove";

import { Mixpanel } from "components/shared/Mixpanel";
import Analytics from "helpers/analytics";

function CartItem(props) {
  const { item, removeFromCart } = props;

  let productName = item.productName;

  if (item.type === "Gift Card") {
    const splitName = item.productName.split("-");

    productName = splitName[1];
  }

  const onClickRemoveProduct = () => {
    removeFromCart(item.id, item.title, item.imgUrl);
    Mixpanel.track("Video removed from cart", {
      JVID: item.id,
      "Video Title": item.title
    });
    Analytics.track("remove_from_cart", {
      ecommerce: {
        currency: "USD",
        value: item.price * item.quantity,
        items: [
          {
            item_name: item.title,
            item_id: item.id,
            quantity: item.quantity
          }
        ]
      }
    });
  };

  const subtotal = Number(item.price) * item.quantity;

  return (
    <Card className="cart__item--container">
      <Link
        className="item--link"
        to={`${item.type === "Gift Card" ? "/licensing/pricing" : `/licensing/view/${item.id}`}`}
      >
        <CardMedia className="item--image" image={item.imgUrl} />

        <div className="item--details">
          <CardContent className="item--fields">
            <Typography className="item--productName">{productName}</Typography>

            <Typography className="item--id">
              {item.type === "Gift Card" ? item.title : `JV# ${item.id}`}
            </Typography>

            <Typography className="item--title">
              {item.type === "Gift Card" ? `x${item.quantity}` : item.title}
            </Typography>
          </CardContent>
        </div>
      </Link>
      <div className="item--cta">
        <span>{`$${subtotal.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`}</span>
        <IconButton className="item--remove" onClick={onClickRemoveProduct}>
          <RemoveIcon />
        </IconButton>
      </div>
    </Card>
  );
}

CartItem.propTypes = {
  item: PropTypes.object.isRequired,
  removeFromCart: PropTypes.func.isRequired
};

export default CartItem;
